const MONTH_NAMES = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

interface DateParts {
  year: number
  month: number
  day: number
}

export interface BillingPeriod {
  startDateEN: string
  endDateEN: string
  periodLabel: string
}

function parseDateParts(dateStr: string | null | undefined): DateParts | null {
  const datePart = (dateStr ?? '').split('T')[0]
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(datePart)
  if (!match) return null

  const year = Number(match[1])
  const month = Number(match[2])
  const day = Number(match[3])
  if (month < 1 || month > 12 || day < 1) return null

  const lastDay = new Date(year, month, 0).getDate()
  if (day > lastDay) return null

  return { year, month, day }
}

function formatMonthYear({ year, month }: DateParts): string {
  return `${MONTH_NAMES[month - 1]} ${year}`
}

function formatFullDate({ year, month, day }: DateParts): string {
  return `${day} ${MONTH_NAMES[month - 1]} ${year}`
}

function sameMonth(a: DateParts, b: DateParts): boolean {
  return a.year === b.year && a.month === b.month
}

export function buildBillingPeriod(
  recordDate: string,
  moveInDate?: string | null,
): BillingPeriod {
  const record = parseDateParts(recordDate)
  if (!record) {
    return {
      startDateEN: recordDate,
      endDateEN: recordDate,
      periodLabel: recordDate,
    }
  }

  let startDateEN = formatMonthYear(record)
  let endDateEN = startDateEN
  const moveIn = parseDateParts(moveInDate)

  if (moveIn && sameMonth(record, moveIn) && moveIn.day > 1) {
    const lastDay = new Date(record.year, record.month, 0).getDate()
    startDateEN = formatFullDate(moveIn)
    endDateEN = formatFullDate({ ...record, day: lastDay })
  }

  return {
    startDateEN,
    endDateEN,
    periodLabel:
      startDateEN === endDateEN ? startDateEN : `${startDateEN} - ${endDateEN}`,
  }
}
